module.exports = __webpack_public_path__ + "img/asset_super sale.aec5c87e.png";